module.exports = __webpack_public_path__ + "static/media/Barmag 1a.72d84f18.jpg";